export type SeoJsonLdObject = Record<string, unknown>

/** 序列化 JSON-LD 并转义脚本结束相关字符，保持内容可被 JSON.parse 读取。 */
export const serializeSeoJsonLd = (schema: SeoJsonLdObject) =>
  JSON.stringify(schema).replaceAll('<', '\\u003C').replaceAll('>', '\\u003E').replaceAll('&', '\\u0026')
